export function getIconClass(icon: string): string {
  if (!icon || typeof icon !== 'string') return '';
  return !icon.startsWith('PMO-') && !icon.startsWith('icon')
    ? 'pi pi-' + icon
    : icon;
}
